import { render } from "./Statusbar.vue?vue&type=template&id=52c7d84e"
import script from "./Statusbar.vue?vue&type=script&lang=ts"
export * from "./Statusbar.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput});
